import excel from "@/libs/excel";
import { isEmpty } from "@/libs/tools";
export default {
	data() {
		return {};
	},
	computed: {},
	methods: {
		openUrl(url, status) {
			if (process.env.NODE_ENV === 'development' && url.indexOf('http') === -1) {
				url = this.$globalUrl + url
			}
			if (status) {
				return url
			} else return window.open(url)
		},
		downloadFile(src, filename) {
			this.getBlob(src).then(blob => {
				this.saveAs(blob, filename);
			});
		},

		getBlob(url, cb) {  //会跨域
			return new Promise(resolve => {
				const xhr = new XMLHttpRequest();
				xhr.open('GET', url, true);
				xhr.responseType = 'blob';
				xhr.onload = () => {
					if (xhr.status === 200) {
						resolve(xhr.response);
					}
				};
				xhr.send();
			});
		},

		toast(content, type) {
			this.$Message[type || 'success']({
				content,
				background: true
			})
		},

		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename);
			} else {
				const link = document.createElement('a');
				const body = document.querySelector('body');
				link.href = window.URL.createObjectURL(blob);
				link.download = filename;
				// fix Firefox
				link.style.display = 'none';
				body.appendChild(link);
				link.click();
				body.removeChild(link);
				window.URL.revokeObjectURL(link.href);
			}
		},
		copy(content, msg = '') {
			if (window.clipboardData) {
				window.clipboardData.setData("text", content);
			} else {
				(function (content) {
					document.oncopy = function (e) {
						e.clipboardData.setData("text", content);
						e.preventDefault();
						document.oncopy = null;
					};
				})(content);
				document.execCommand("Copy");
			}
			this.$Message["success"]({
				background: true,
				content: msg + (this.$t("copy") + this.$t("success")),
				duration: 5
			});
		},
		toFixed(number, digit = 2) {
			return number && parseFloat(number).toFixed(digit);
		},
		exportExc(params) {
			let name = "";
			let data = null;
			let fields = [];
			let origin = false
			if (typeof params === "object" && params.origin) origin = true, params = '';
			if (typeof params === "object") {
				name = params.name;
				data = params.data && JSON.parse(JSON.stringify(params.data));
				fields = params.fields || [];
			} else {
				name = params;
				data = JSON.parse(JSON.stringify(this.selectAll));
				fields = this.fields || [];
			}

			if (data && data.length) {
				let field = fields
					.filter(item => {
						if (item.show) return item.show.call(this);
						return !item.type || item.type == "html";
					})
					.reduce(
						(b, a) => {
							a.key && b.key.push(a.key),
								a.name && b.name.push(this.isMethod(a.name));
							return b;
						},
						{ key: [], name: [] }
					);

				let renderFields = fields.filter(
					item => !item.type && item.methods && (item.methods.render || item.methods.export)
				);
				data.forEach(item =>
					renderFields.forEach(
						field =>
						(item[field.key] = (field.methods.export || field.methods.render).call(this, {
							row: item,
							field,
							value: item[field.key]
						}))
					)
				);
				if ((params && params.fields && params.fields.length) || origin) {
					const excData = {
						title: field.name,
						key: field.key,
						data,
						autoWidth: true,
						origin: origin,
						filename: this.$t(name || this.$route.name)
					};
					excel.export_array_to_excel(excData);
				} else {
					let config = {
						filename: this.$t(name || this.$route.name),
						type: "xlsx",
						sheetName: "sheet",
						mode: "current",
						data,
						message: false,
						isMerge: true,
						afterExportMethod: () => {
							this.exportLoading = false;
							this.config.hideVisible && this.config.hideVisible.forEach(t => {
								this.getTable().hideColumn(t)
							})
						}
					}
					if (params && params.columns) config.columns = params.columns
					this.config.hideVisible && this.config.hideVisible.forEach(t => {
						this.getTable().showColumn(t)
					})
					this.getTable().exportData(config);
				}
			} else {
				this.$Message["error"]({
					background: true,
					content: "Export data cannot be empty !",
					duration: 5
				});
			}
			this.getTable().clearCheckboxRow();
			this.checkTable([]);

			// this.getList();
		},
		isMethodDefault(methods, params, df) {
			if (typeof methods === "function") return methods.call(this, params);
			return df;
		},
		isMethod(methods, params, df) {
			if (typeof methods === "function") return methods.call(this, params);
			return methods !== undefined ? methods : df;

		},
		handleMethod(params = {}) {
			let { methods, name, row, field } = params;
			if ("searchForm" in params && "fields" in params) {
				params["fields"].forEach(el => {
					if (
						Object.prototype.toString.call(params["searchForm"][el.key]) ==
						"[object Object]" &&
						!Object.keys(params["searchForm"][el.key]).length
					) {
						delete params["searchForm"][el.key];
					}
					if (
						Object.prototype.toString.call(params["searchForm"][el.key]) ==
						"[object Array]" &&
						!params["searchForm"][el.key].length
					) {
						delete params["searchForm"][el.key];
					}
					if (
						(!params["searchForm"][el.key] &&
							params["searchForm"][el.key] !== 0) ||
						(Array.isArray(params["searchForm"][el.key]) &&
							params["searchForm"][el.key].length === 0)
					) {
						delete params["searchForm"][el.key];
					}
					if (el.component === "DatePicker" && params["searchForm"][el.key]) {
						params["searchForm"][el.key] = this.format.timeFormat(
							params["searchForm"][el.key],
							el.format
						);
					}
				});
			}
			if (methods && methods[name] && typeof methods[name] === "function")
				return methods[name].call(this, {
					...params,
					row,
					field,
					value: row && row[field && field.key]
				});

		},
		handleMethods(name, params) {
			if (this.methods[name]) return this.methods[name].call(this, params);
		},
		handleRequestMethods(name, params, isTips, isWait, isDel) {
			if (isWait) this.openLoading();
			return new Promise(async (resolve, rej) => {
				try {
					if (this.methods[name]) {
						// 是否删除空参数
						if (isDel) {
							for (let i in params) {
								if (isEmpty(params[i])) {
									delete params[i];
								}
							}
						}
						let res = await this.methods[name](params);
						if (isWait) this.closeLoading();
						let setT = setTimeout(() => {
							this.closeLoading();
							clearTimeout(setT);
						}, 100000);
						if (res.status !== 200) {
							this.$Message.error({
								background: true,
								content: this.$t("NetworkError"),
								duration: 5
							});
							return;
						}
						if (res.data.code === 0 || res.data.status) {
							if (isTips)
								this.$Message.success(
									this.$t("operation") + this.$t("success")
								);
							return resolve(res.data);
						} else {
							this.closeLoading();
							//   this.$Message.error({
							//     background: true,
							//     content: res.data.message || res.data.msg,
							//     duration: 5
							//   });
							//   // rej(res);
							//   return;
							rej(res);
						}
					} else {
						rej({ message: "未定义" });
						return console.warn("未定义", name);
					}
				} catch (e) {
					rej(e);
				}
			});
		},
		getObj(o, j, u, v) {
			return loop(o, j, u, v);
			function loop(o, j, u, v) {
				if (typeof j === "string") j = j.split(".");
				let t = j[0];
				if (u) {
					t = t[0].toLocaleUpperCase() + t.substring(1);
				}
				j.splice(0, 1);
				if (j.length) {
					if (!o[t]) o[t] = isNaN(Number(j[0])) ? {} : [];
					return loop(o[t], j, u, v);
				} else {
					if (v !== undefined) o[t] = v;
					return o[t];
				}
			}
		},
		readFile(file, num = 0) {
			return new Promise((res, rej) => {
				const reader = new FileReader();
				reader.readAsArrayBuffer(file);
				reader.onerror = e => {
					this.$Message.error("file read error");
					rej(false)
				};
				reader.onload = e => {
					const data = e.target.result;
					const { header, results } = excel.read(data, "array");
					if (num) results.splice(0, num);
					if (results.length == 0) {
						this.$Message["error"]({
							background: true,
							content: "No Data",
							duration: 3
						});
						rej(false)
						return;
					}
					res(results)
				};
			})
		},
	}
};
